import {Link} from "react-router-dom";

const AddButton = ({to, text}) => {
    return <Link to={to} className="btn btn-sm btn-success ml-1 mr-1">
        <i className="fas fa-plus" />&nbsp;&nbsp;&nbsp;{text}
    </Link>
};

export default AddButton;
